var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgStopWatch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "stopWatch_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    strokeWidth: 0
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M3.4 5.4C0 8.7 0 14.1 3.3 17.4c3.3 3.4 8.7 3.4 12 .1 3.4-3.3 3.4-8.7.1-12-3.2-3.3-8.6-3.4-12-.1zm10.9 11.2c-2.8 2.7-7.3 2.7-10-.1s-2.7-7.3.1-10 7.3-2.7 10 .1 2.7 7.2-.1 10z",
    className: "stopWatch_svg__st0"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M5.3 7.3c-.6.6 2.3 4.6 3 5.3.6.6 1.6.6 2.2 0 .6-.6.6-1.6 0-2.2-.6-.6-4.6-3.7-5.2-3.1zM6 1.1c-.2.1-.4.3-.6.6l-1 1.6c2.8-2 6.6-2.1 9.5-.3L13 1.5c-.2-.3-.4-.5-.7-.6C9.8-.4 8.6-.3 6 1.1zm12.8 3.1l-1.4 1.4-2.1-2.1 1.4-1.4c.4-.4 1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4z",
    className: "stopWatch_svg__st0"
  })));
}
export default SvgStopWatch;